const RUT_REGEX = /^(\d{1,2}\.)?(\d{3}\.)?(\d{3})-([\dkK])$/;

export function cleanRut(value: string): string {
    return value.replace(/\./g, "").replace(/-/g, "");
}

export function formatRut(value: string): string {
    const cleaned = value.replace(/[^\dkK]/g, "").toUpperCase();
    if (!cleaned) return "";

    const body = cleaned.slice(0, -1);
    const dv = cleaned.slice(-1);

    if (!body) return dv;

    const formattedBody = body
        .replace(/^0+/, "")
        .split("")
        .reverse()
        .reduce((acc, digit, i) => {
            if (i > 0 && i % 3 === 0) acc.push(".");
            acc.push(digit);
            return acc;
        }, [] as string[])
        .reverse()
        .join("");

    return `${formattedBody}-${dv}`;
}

export function validateRut(rut: string): boolean {
    const cleaned = cleanRut(rut);
    if (cleaned.length < 2) return false;

    const body = cleaned.slice(0, -1);
    const dv = cleaned.slice(-1).toUpperCase();

    if (!/^\d+$/.test(body)) return false;

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body[i], 10) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const remainder = 11 - (sum % 11);

    let expectedDv: string;
    if (remainder === 11) {
        expectedDv = "0";
    } else if (remainder === 10) {
        expectedDv = "K";
    } else {
        expectedDv = remainder.toString();
    }

    return dv === expectedDv;
}
